import type { TPackageRow } from '@/interfaces';

export const formatPromotionPackageValue = (v: number, unit: TPackageRow['unit']): string => {
	if (unit === 'coins') return v.toLocaleString('fr-FR');
	if (unit === 'mois') return `${Math.round(v * 10) / 10} mois`;
	const h = Math.floor(v / 60);
	const m = Math.round(v % 60);
	return m === 0 ? `${h}h` : `${h}h${String(m).padStart(2, '0')}`;
};
